// @flow
export { default } from './EstimateBoxTemplate';



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateBoxTemplate/index.js